<section class="container-fluid pt-4">

    <div class="row mx-4">
        <div class="col-12 d-flex justify-content-between ">
          <h2 class="text-left text-white px-5 my-4">Reprogramar Pago de {{title}}</h2>
    
          <div class="d-flex justify-content-center align-items-center">
            <button
            class="badge rounded-pill btn btn-outline-light mx-2"
            [routerLink]="['/pdg/project/pay/list',idProject,title]" 
          >
            <i
              class="fa-solid fa-right-from-bracket m-2 fs-6"
              aria-hidden="true"
            ></i>
            <span class="m-2 fs-6">Volver al listado</span>
          </button>
          </div>
    
    
        </div>
      </div>

</section>

<div class="mx-5">

    <section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
        <div class="my-1 container-fluid d-flex justify-content-between align-items-center">
            <div>
                <h5 class="ms-3">Reprogramar pago.</h5>
            </div>
        </div>
            <div class="componente-importantes text-start  mt-3" style="min-height:700px;">
                <form action="" method="post" (submit)="formSubmit()" [formGroup]="createPayForm">
    

                    <div class="row">
                        <form action="" [formGroup]="infoPayForm">
                            <div class="row">
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 mx-5">Pago</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 float-start">: {{this.datos.title}}</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 mx-5">Monto</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 float-start">: {{this.datos.pay_amount}}</label>
    
                        </div>
    
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 mx-5">Porcentaje de pago</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 float-start">: {{this.datos.amount_percent}}%</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 mx-5">Fecha programada</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 float-start">: {{this.datos.scheduled_date}}</label>
    
                        </div>
                        <div class="col-3">
    
                            <label for="formControlInput" class="form-label mt-3 mx-5">Estado</label>
    
                        </div>


                        <div class="col-3">
    
                            <span *ngIf="this.datos.status === 'REPROGRAMADO'"
                            class="badge rounded-pill text-bg-warning form-label mt-3 float-start" style="font-size: 12px;">{{this.datos.status}}</span>
                            <span *ngIf="this.datos.status === 'PAGADO'"
                            class="badge rounded-pill text-bg-success  form-label mt-3 float-start" style="font-size: 12px;">{{this.datos.status}}</span>
                            <span *ngIf="this.datos.status === 'ANULADO'"
                            class="badge rounded-pill text-bg-danger form-label mt-3 float-start" style="font-size: 12px;">{{this.datos.status}}</span>
                            <span *ngIf="this.datos.status === 'PENDIENTE'"
                            class="badge rounded-pill text-bg-info form-label mt-3 float-start" style="font-size: 12px;">{{this.datos.status}}</span>
                            <span *ngIf="this.datos.status === 'CREADO'"
                            class="badge rounded-pill text-bg-creado form-label mt-3 float-start" style="font-size: 12px;">{{this.datos.status}}</span>
    
                        </div>
                    </div>
                    </form>
                    </div>
    
                
    
                    <div class="form-group m-5">
                        <label for="formControlInput" class="form-label">Fecha Programada:</label>
                        <input type="date" class="form-control custom-outline-input date" id="date_reschedule"
                            formControlName="date_reschedule">
                    </div>
                    <div class="form-group m-5">
                        <label for="formControlInput" class="form-label">Observaciones:</label>
                        <textarea
                        class="form-control custom-outline-input date"
                        placeholder="Dejar detalles aqui..."
                        formControlName="description"
                        id="description"
                        style="height: 100px !important"
                        ></textarea>
                    </div>
    
                
                    <div class="form-group d-flex justify-content-sm-end mt-4">
                        <div>
                            <button class="btn btn-outline-light me-3" style="font-size: 15px;"> <i _ngcontent-xfk-c127=""
                                    class="fa-solid fa-floppy-disk m-1"></i> Guardar </button>
                        </div>
    
    
    
    
                    </div>
    
    
                </form>
    
    
            </div>
    
    

    </section>
</div>


<router-outlet></router-outlet>